<script>
import transitionFade from '../transition/fade';
import shadowBox from '../shadow';
export default {
    props: {
        status: {
            type: Boolean,
            default: false,
        },
        params: {
            type: Object,
            default: function () {
                return {};
            }
        }
    },
    data() {
        return {
            innerStatus: this.status,
            zIndex: 120
        };
    },
    methods: {
        confirm() {
            this.innerStatus = false;
            this.$emit('update:status', this.innerStatus);
        },
        show() {
            this.innerStatus = true;
        },
        hide() {
            this.innerStatus = false;
        }
    },
    watch: {
        innerStatus() {
            if (this.innerStatus) {
                this.$emit('show');
            } else {
                this.$emit('hide');
            }
        }
    },
    components: {
        transitionFade,
        shadowBox
    }
}
</script>

<template>
    <shadow-box 
        :status="innerStatus"
        :zIndex="zIndex"
    >
        <transition-fade>
            <div v-if="innerStatus" class="modal-container">
                <slot></slot>
            </div>
        </transition-fade>
    </shadow-box>
</template>

<style lang="stylus" scoped>
.modal-container
    width 100%;
    height 100%
</style>